module.exports = __webpack_public_path__ + "img/logo_navbar.6effe2c6.png";